(async () => {
    if (!customElements.get("recommended-products-section")) {
        class RecommendedProducts extends HTMLElement {
            constructor() {
                super();
                this.initialise()
            }
            initialise() {
                this.swiperContainer = this.querySelector("[data-swiper-container]");
                this.swiperOptions = {
                    loop: true,
                    navigation: {
                        nextEl: this.querySelector(".swiper .swiper-button-next"),
                        prevEl: this.querySelector(".swiper .swiper-button-prev")
                    },
                    spaceBetween: 10,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.3,
                            centeredSlides: true
                        },
                        768: {
                            slidesPerView: 2
                        },
                        1024: {
                            slidesPerView: 3
                        },
                        1440: {
                            slidesPerView: 4
                        }
                    }
                };
                this.swiperInstance = new Swiper(this.swiperContainer, this.swiperOptions);
                Fancybox.bind("[data-fancybox]", {})
            }
        }
        customElements.define("recommended-products-section", RecommendedProducts)
    }
})();
//# sourceMappingURL=recommended-products.js.map